"use client";

import type { ReactNode } from "react";
import { createContext, useContext, useMemo } from "react";

/**
 * Morph group: shared exclusive id so badge hops keep one portal
 * (instance ownership inside the exclusive store; ContentTooltip
 * `transition="morph"` for panel motion).
 */
const ContentTooltipGroupContext = createContext<string | null>(null);

export interface ContentTooltipGroupProps {
	groupId: string;
	children: ReactNode;
}

export function ContentTooltipGroup({
	groupId,
	children,
}: ContentTooltipGroupProps) {
	const value = useMemo(() => groupId, [groupId]);
	return (
		<ContentTooltipGroupContext.Provider value={value}>
			{children}
		</ContentTooltipGroupContext.Provider>
	);
}

export function useContentTooltipGroupId(): string | null {
	return useContext(ContentTooltipGroupContext);
}
